import React from "react";
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const defaultHeader = [
  { displayName: "Head 1", key: "head1" },
  { displayName: "Head 2", key: "head2" },
  { displayName: "Head 3", key: "head3" },
  { displayName: "Head 4", key: "head4" },
  { displayName: "Head 5", key: "head5" },
];

const CustomTableILayout = ({
  colorInvert,
  tableHeader = defaultHeader,
  tableRows = [],
  tableName,
}) => {
  return (
    <Paper elevation={6} square sx={{ p: 2 }}>
      <Typography
        sx={{
          fontWeight: 700,
          textTransform: "uppercase",
          display: "inline-block",
          background: "linear-gradient(to right, #008ffb, #00e396)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          borderBottom: "2px solid #008ffb",
        }}
      >
        {tableName || "Table Name"}
      </Typography>

      <Box
        mt={2}
        sx={{
          overflowY: "auto",
          maxHeight: 500,
          borderRadius: "15px",
          // border: "1px solid black",
          "&::-webkit-scrollbar": {
            width: "0px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "transparent",
          },
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <Table
          stickyHeader
          sx={{
            minWidth: 500,
            borderCollapse: "separate",
            borderSpacing: 0,
          }}
        >
          <TableHead>
            <TableRow>
              {tableHeader.map((header) => (
                <TableCell
                  key={header?.key}
                  align="center"
                  sx={{
                    backgroundColor: "#000000de",
                    color: "white",
                    fontWeight: "bold",
                    border: "1px solid #ccc",
                    //  fontSize: "0.9rem",
                    // textTransform: "uppercase",
                    
                  }}
                >
                  {header?.displayName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableRows.length > 0 ? (
              tableRows.map((row, rowIndex) => (
                <TableRow
                  key={rowIndex}
                  sx={{
                    // background: colorInvert
                    //   ?" linear-gradient(to right,rgba(0, 142, 251, 0.44),rgba(0, 227, 151, 0.39))"
                    //   : "linear-gradient(to right, #008ffb, #00e396)",
                    background: "#919eab1f",
                    "&:last-child td": { borderBottom: 0 },
                  }}
                >
                  {tableHeader.map((header, cellIndex) => (
                    <TableCell
                      key={cellIndex}
                      align="center"
                      sx={{
                        border: "1px solid #ccc",
                         fontWeight: "500",
                        
                      }}
                    >
                      {row?.[header.key] ?? "N/A"}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  align="center"
                  colSpan={tableHeader.length}
                  sx={{
                    fontStyle: "italic",
                    py: 3,
                    // background: colorInvert
                    //   ? "linear-gradient(to right, #00e396, #008ffb)"
                    //   : "linear-gradient(to right, #008ffb, #00e396)",
                    backgroundColor: "#919eab1f",
                    "&:last-child td": { borderBottom: 0 },
                  }}
                >
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Box>
    </Paper>
  );
};

export default CustomTableILayout;
